import { useWindowSize } from "PFCore/helpers/use_window_size";

const DEFAULT_WIDTH_BREAKPOINT = 700;

export const useIsMobile = (widthBreakpoint = DEFAULT_WIDTH_BREAKPOINT): boolean => {
  const { windowWidth } = useWindowSize();

  return windowWidth <= widthBreakpoint;
};
